import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './PayrollListScreen';
import PayrollList from './PayrollListScreen';
import { StoreState } from 'src/store/reducers';
import { getPayrolls, updatePayroll, getPayrollsCsv } from 'src/store/actions/payroll-actions';
import { QueryParams } from 'src/types/grid';
import { toast } from 'react-toastify';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.payrolls.data,
        inProgress: state.payrolls.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getPayrolls(params)),
        getDataCsv: (params: QueryParams) => dispatch(getPayrollsCsv(params)),
        updatePayroll: ({ status, id, setPopup }: any) =>
            dispatch(
                updatePayroll(
                    { status, id },
                    () => {
                        toast.success('Status changed successfully');
                        setPopup(false);
                    },
                    (errorMessage: string) => {
                        setPopup(false);
                        toast.error(errorMessage);
                    },
                ),
            ),
    };
}

const PayrollListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(PayrollList);

export default PayrollListScreen;
